import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import InputOTA from '~/features/base/components/forms/ota/InputOTA';
import DeviceTypeFormItem from '~/features/base/components/forms/DeviceTypeFormItem';
import NumberInputOTA from '~/features/base/components/forms/ota/NumberInputOTA';

interface CampaignDetailsFormProps {
  control: Control<any>;
  errors?: FieldErrors;
  disabled?: boolean;
}

const CampaignDetailsForm: React.FC<CampaignDetailsFormProps> = ({
  control,
  errors,
  disabled = false
}) => {
    const intl = useIntl();

    return (
    <div>
        <div className="margin-bottom-20">
            <p className='text-color-gray'>
                <FormattedMessage id='intl-msg:campaign:detailsForm:description'/>
            </p>
        </div>
        <div className={'display-flex gap-20 margin-top-20'}>
        <div className='width-50pct'>
          <Controller
            control={control}
            name='campaignName'
/*
            rules={{ required: 'Campaign name is required' }}
*/
            render={({ field, fieldState: { error } }) => (
              <InputOTA
                  title={'Campaign Name'}
                type='text'
                className='form-control'
                value={field.value}
                  placeholder={intl.formatMessage({ id: 'intl-msg:campaign:detailsForm:campaignName:placeholder' })}
                onChange={field.onChange}
                hasError={!!error}
                errorMessage={error?.message}
                disabled={disabled}
              />
            )}
          />
        </div>
      </div>

      <div className={'display-flex gap-20 margin-top-20'}>
        <div className='width-50pct'>
          <Controller
            control={control}
            name='deviceType'
/*
            rules={{ required: 'Device type is required' }}
*/
            render={({ field, fieldState: { error }, formState:onChange }) => (
                <DeviceTypeFormItem
                    onChange={optionSelected => {
                        field.onChange(optionSelected);
                    }}
                    value={field.value}
                    hasError={!!error}
                    errorMsg={error?.message}
                />
            )}
          />
        </div>
        <div className='width-50pct'>
          <Controller
            control={control}
            name='decisionBoardUrl'
/*
            rules={{
              required: 'Decision Board URL is required',
              pattern: {
                value: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
                message: 'Please enter a valid URL'
              }
            }}
*/
            render={({ field, fieldState: { error } }) => (
              <InputOTA
                  title={intl.formatMessage({ id: 'intl-msg:campaign:decisionBoardUrl' })}
                type='url'
                className='form-control'
                value={field.value}
                placeholder={'Enter decision board URL'}
                onChange={field.onChange}
                hasError={!!error}
                errorMessage={error?.message}
                disabled={disabled}
              />
            )}
          />
        </div>
      </div>

      <div className={''}>
        <Controller
          control={control}
          name='description'
          render={({ field, fieldState: { error } }) => (
            <InputOTA
                title={intl.formatMessage({ id: 'intl-msg:campaign:additionalInformation' })}
              className='form-control'
              value={field.value}
                placeholder={intl.formatMessage({ id: 'intl-msg:campaign:additionalInformation:placeholder' })}
              onChange={field.onChange}
              hasError={!!error}
              errorMessage={error?.message}
              disabled={disabled}
              rows={4}
            />
          )}
        />
      </div>
      <div className={'margin-top-20'}>
        <Controller
          control={control}
          name='stageNumber'
            /*
              rules={{ required: 'Campaign manager is required' }}
  */
          render={({ field, fieldState: { error } }) => (
              <div className='width-200'>
                  <NumberInputOTA
                      label={intl.formatMessage({ id: 'intl-msg:campaign:estimatedNumberOfStages' })}
                      className=''
                      value={field.value}
                      placeholder={intl.formatMessage({ id: 'intl-msg:campaign:estimatedNumberOfStages:placeholder' })}
                      onChange={field.onChange}
                      hasError={!!error}
                      errorMessage={error?.message}
                      disabled={disabled}
                  />
              </div>
          )}
        />
      </div>
    </div>
  );
};

export default CampaignDetailsForm;
